import { Controller } from "@hotwired/stimulus"

// QR 완료 화면 — 가능하면 창을 닫고, 안 되면 안내 문구를 보여준다.
//
// 브라우저는 스크립트로 열지 않은 창의 window.close()를 무시한다. QR 스캐너가
// 연 탭이 여기 해당하는데, 스캐너 인앱 브라우저는 허용하는 경우도 있어 일단
// 시도해 본다. 닫히면 이 코드 이후는 실행되지 않고, 안 닫히면 fallback을 드러낸다.
//
// CSP가 strict-dynamic + nonce라 인라인 <script>는 막힌다 — 그래서 번들에 포함되는
// Stimulus 컨트롤러로 둔다.
//
// Auto-registered via the controllers/index.js esbuild glob (do NOT edit index.js).
export default class extends Controller {
  static targets = ["fallback"]

  connect() {
    try {
      window.close()
    } catch (_) {
      // 무시 — 아래 fallback 노출로 처리한다
    }
    // close()가 먹히면 이 타이머는 실행되지 않는다.
    this.timer = setTimeout(() => this.revealFallback(), 400)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  revealFallback() {
    if (this.hasFallbackTarget) this.fallbackTarget.classList.remove("hidden")
  }
}
